import React from "react"
import { Flex } from "@theme-ui/components"
import SingleColumn from "./singleColumn"
import { useBreakpointIndex } from "@theme-ui/match-media"

const MultiColumn = ({ data }) => {
    const breakpointIndex = useBreakpointIndex()
    const content = data.map((value, idx) => (
        <SingleColumn key={idx} data={value} multi={true} />
    ))
    return (
        <Flex sx={{ flexDirection: breakpointIndex <= 4 ? "column" : "row" }} className="multi-column">
            {content}
        </Flex>
    )
}

export default MultiColumn
